import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { AccountLookupComponent } from './account-lookup.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [AccountLookupComponent],
  exports: [AccountLookupComponent],
  providers: []
})
export class AccountLookupModule { }
